<template>
  <div class="col-lg h-25 p-0 " style="background: none">
    <div class="row mx-auto shadow border-radius">
      <div class="pt-5 mx-auto    w-50">
        <div
            class="
            w-50
            embed-responsive embed-responsive-1by1
            mx-auto
            img-container
          "
        >
          <img
              :src="profilePictureUrl"
              class="img-fluid img embed-responsive-item rounded-circle"
              alt="profile picture"
          />

          <button
              v-if="getMe.uid === user.uid"
              type="button"
              data-toggle="modal"
              data-target="#cameraModal"
              class="img-btn"
          >
            <i class="fas fa-camera"></i>
          </button>
        </div>

        <div
            class="modal fade"
            id="cameraModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="cameraModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="cameraModalLabel">
               {{$t('profile.picture.update')}}
                </h5>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="state ? changeState() : ''"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div v-if="!fileToggle" class="col">
                    <button
                        type="button"
                        class="btn"
                        :class="{ 'btn-primary': !state, 'btn-danger': state }"
                        @click="changeState()"
                    >
                      <span v-if="!state">{{$t('profile.picture.takePhoto')}}</span>
                      <span v-if="state">{{$t('profile.picture.closeCamera')}}</span>
                    </button>
                  </div>
                  <div v-if="!state" class="col">
                    <button
                        @click="toggleFileSelect()"
                        type="button"
                        class="btn"
                        :class="{
                        'btn-primary': !fileToggle,
                        'btn-danger': fileToggle,
                      }"
                    >
                      <span v-if="!fileToggle">{{$t('profile.picture.upload')}}</span>
                      <span v-if="fileToggle">{{$t('ui.cancel')}}</span>
                    </button>
                  </div>
                </div>

                <div class="mt-2" v-if="fileToggle">
                  <form @submit="uploadSelectedFile">
                    <div class="form-group">
                      <div id="fileSelect">

                      </div>
                      <label class="btn btn-primary col-6 mt-3" for="photoUploadInput">
                        <div id="labelContainer">
                          <div>{{$t('profile.picture.selectPhoto')}}</div>
                          <div><i class="far fa-image"></i></div>
                        </div>
                      </label>

                      <input
                          type="file"
                          accept="image/png, image/jpeg"
                          class="form-control-file mb-3"
                          id="photoUploadInput"
                          @change="processFile($event)"
                      />
                      <canvas
                          id="photoUploadCanvas"
                          ref="photoUploadCanvas"
                          :width="photoCanvasWidth"
                          :height="photoCanvasHeight"
                      ></canvas>
                      <button id="photoBtn" class="mt-2 btn btn-primary">{{ $t('ui.save') }}</button>
                    </div>
                  </form>
                </div>
                <camera
                    @uploaded="uploadedPhoto($event)"
                    @cameraState="handleCameraState($event)"
                    @captured="handleCapture($event)"
                    :user="user"
                    :state="state"
                    :capturedState="captured"
                ></camera>
              </div>
            </div>
          </div>
        </div>

        <div class="w-75 mx-auto text-center">
          <h3 class="pt-3">{{ user.displayName }}</h3>
          <p>
            <small>{{$t('profile.joinedSince')}} <br>{{ formattedUserCreationDate }}</small>
          </p>
          <p v-if="getTotalTimeInPlatform">
            <small>{{$t('profile.totalTimeInPlatform')}}<br> {{formattedColonTime(getTotalTimeInPlatform)}}            </small>
          </p>
        </div>
      </div>

      <!-- <div class="w-75 pb-2 mx-auto row justify-content-between">
        <div class="col-6">
          <div class="mx-auto octagon text-center"><h2>4</h2></div>
        </div>

        <div class="col-6 text-center">
          <h2>4578</h2>
          <p>total points</p>
        </div>
      </div>

      <div class="w-75 mx-auto pb-4">
        <div class="progress border-0">
          <div
            class="progress-bar rounded"
            role="progressbar"
            style="width: 66%"
            aria-valuenow="66"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <p><small>75 points to level 5</small></p>
      </div> -->

      <!--      <div class="w-75 pb-2 mx-auto row">-->
      <!--        <router-link-->
      <!--          v-if="uwesBtn === true"-->
      <!--          tag="button"-->
      <!--          class="my-2 mx-auto p-3 btn-primary rounded border-0"-->
      <!--          :to="'/uwes/' + this.user.uid"-->
      <!--        >-->
      <!--          <strong>Fill in the Work and Well-being form</strong>-->
      <!--        </router-link>-->

      <!--        <router-link-->
      <!--          v-if="evaluationBtn === true"-->
      <!--          tag="button"-->
      <!--          class="my-2 mx-auto p-3 btn-primary rounded border-0"-->
      <!--          :to="'/evaluation/' + evaluationId"-->
      <!--        >-->
      <!--          <strong>Fill in an evaluation form for {{ evaluateeName }}</strong>-->
      <!--        </router-link>-->
      <!--      </div>-->

      <!-- <div class="w-100 mx-auto p-5">
        <h3>Lifetime stats:</h3>
        <div class="row">
          <div class="col-8"><p>Submitted comments</p></div>
          <div class="col-4 text-right"><p>125</p></div>
        </div>
        <div class="row">
          <div class="col-8"><p>Submitted impediments</p></div>
          <div class="col-4 text-right"><p>67</p></div>
        </div>
        <div class="row">
          <div class="col-8"><p>Submitted improvements</p></div>
          <div class="col-4 text-right"><p>23</p></div>
        </div>
        <div class="row">
          <div class="col-8"><p>Jobs done</p></div>
          <div class="col-4 text-right"><p>1268</p></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import camera from "@/components/general/camera/camera2.vue";
import firebase from "firebase/app";
import timeCalc from "@/mixins/timeCalc";
export default {
  mixins: [timeCalc],
  props: ["user", "uwesBtn", "evaluation"],
  components: {
    camera,
  },
  computed: {
    ...mapGetters("users", ["getMe", "getClaims", "getUser"]),
    ...mapGetters('userData', ['getTotalTimeInPlatform']),
    formattedUserCreationDate() {

      return this.user.metadata ? moment(this.user.metadata.creationTime).format('DD/MM/YY')   : ''
    }
  },
  data() {
    return {
      evaluationBtn: false,
      evaluationId: null,
      evaluateeId: null,
      evaluateeName: null,
      state: false,
      fileToggle: false,
      fileData: null,
      captured: false,
      profilePictureUrl: "",
      photoCanvasHeight: 0,
      photoCanvasWidth: 0,
    };
  },

  // mounted() {
  //   this.setButtonState()
  // },
  methods: {
    handleCapture(val) {
      this.captured = val;
    },
    uploadedPhoto(bool) {
      if (bool === true) {
        $("#cameraModal").modal("hide");
        this.getProfilePicture();
        this.swalToastSuccess(this.$t("ui.saved"));
      }
    },
    handleCameraState(val) {
      this.state = val;
    },
    changeState() {
      this.state = !this.state;
    },
    toggleFileSelect() {
      this.fileToggle = !this.fileToggle;
    },
    processFile(event) {
      const self = this;
      let reader,
          files = event.target.files;

      reader = new FileReader();
      // const canvas = this.$refs.photoUploadCanvas;
      reader.onload = (e) => {
        let img = new Image();
        img.onload = function () {
          const inputWidth = document.getElementById("photoBtn");
          let multiplier = img.height / img.width;
          self.photoCanvasHeight = multiplier * inputWidth.offsetWidth;
          self.photoCanvasWidth = inputWidth.offsetWidth;
          self.drawCanvasImage(
              img,
              self.photoCanvasWidth,
              self.photoCanvasHeight
          );
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(files[0]);
      // this.fileData = event.target.files[0];
      // if (this.fileData.size > 524288) {
      //   this.fileDate = null;
      //   this.swalError("File Size is too big");
      //   document.getElementById("photoUploadInput").value = "";
      // }
    },
    drawCanvasImage(img, x, y) {
      let self = this;
      console.log("canvas width: ", x);
      console.log("canvas height: ", y);
      var canvas = this.$refs.photoUploadCanvas;
      setTimeout(function () {
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, x, y);
      }, 500);
    },
    async uploadSelectedFile(event) {
      event.preventDefault();

      const fileCanvas = document
          .getElementById("photoUploadCanvas")
          .toDataURL("image/jpeg");
      // .replace("image/jpeg", "image/octet-stream");
      //   download.setAttribute("href", canvas);
      const storageRef = firebase
          .storage()
          .ref("users/" + this.user.uid + "/profile.jpg");
      await storageRef
          .putString(fileCanvas, "data_url")
          .then(function () {
            console.log("Uploaded succesfully");
            $("#cameraModal").modal("hide");

          })
          .catch((error) => {
            console.log(error.message);
          });
    await   this.getProfilePicture();
      this.swalToastSuccess(this.$t("ui.saved"));
      // if (this.fileData !== null) {
      //   const storageRef = firebase
      //     .storage()
      //     .ref("users/" + this.user.uid + "/profile.jpg");
      //   await storageRef
      //     .put(this.fileData)
      //     .then(function () {
      //       console.log("Uploaded succesfully");
      //     })
      //     .catch((error) => {
      //       console.log(error.message);
      //     });
      //   this.toggleFileSelect();
      //   $("#cameraModal").modal("hide");
      //   this.getProfilePicture();
      //   this.swalToastSuccess(this.$t("ui.saved"));
      // } else {
      //   this.swalError("Please select a file first");
      // }
    },
    async setButtonState() {
      if (this.evaluation.assignedEvaluators && this.user) {
        if (
            this.evaluation.assignedEvaluators.includes(this.user.uid) &&
            this.$route.params.userId === (await this.getMe.uid)
        ) {
          this.evaluateeId = this.evaluation.evaluatee.uid;
          this.evaluationId = this.evaluation.id;
          if (this.evaluation.evaluatee.displayName === this.user.displayName) {
            this.evaluateeName = "yourself";
          } else {
            this.evaluateeName = this.evaluation.evaluatee.displayName;
          }

          this.evaluationBtn = true;
        }
      }
    },
    async getProfilePicture() {

      if(!this.getMe.photoURL){

      firebase
          .storage()
          .ref("users/" + this.user.uid + "/profile.jpg")
          .getDownloadURL()
          .then((imgUrl) => {
            this.profilePictureUrl = imgUrl;
          })
          .catch((error) => {
            console.log(error.message);
            this.profilePictureUrl =
                "https://www.medtalks.nl/images/user-placeholder.jpg";
          });

      }else{
        this.profilePictureUrl = this.getMe.photoURL;

      }
    },
  },
   created() {
    this.setButtonState();
    this.getProfilePicture();
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";

// #photoUploadCanvas{
//   position: relative;
//   width: 80%;
//   left: 10%;
// }

#labelContainer {
  i {
    font-size: 2.5rem
  }

  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: auto;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  align-items: center;
}

#photoUploadInput {
  height: 1px;
  width: 1px;
}

.img {
  object-fit: cover;
}

.img-container {
  position: relative;

  .img-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    background-color: #c4c4c4;
    border: 0px;
    border-radius: 50%;
    width: 35px;
    height: 35px;

    i {
      color: white;
    }

    &:hover {
      background-color: #929292;
      cursor: pointer;
    }
  }
}

.modal-body {
  button {
    width: 100%;
  }
}
</style>